import { withDefaultContextAsSelectedProject } from './api-default-context';
import { getStatementIdUtil } from 'utils/statement-export-utils';
import { PROCESS_TYPES } from 'components/feature/toolkit/chatbot-toolkit-panel/toolkit-chatbot-utils';

export const getStatementSummaryNotesRequest = ({ revisionId }) =>
  withDefaultContextAsSelectedProject().get(
    `/tieout/statements/${getStatementIdUtil()}/revisions/${revisionId}/summary/notes`,
  );

export const getStatementSummaryElementsRequest = ({ revisionId }) =>
  withDefaultContextAsSelectedProject().get(
    `/tieout/statements/${getStatementIdUtil()}/revisions/${revisionId}/summary/elements`,
  );

export const getStatementSummarySectionsRequest = ({ revisionId, isOCR }) =>
  withDefaultContextAsSelectedProject().get(
    `/tieout/statements/${getStatementIdUtil()}/revisions/${revisionId}/summary/${
      isOCR ? 'bookmarkreviews' : 'sectionreviews'
    }`,
  );

export const getStatementSummaryStatusRequest = ({ revisionId }) =>
  withDefaultContextAsSelectedProject().get(
    `/tieout/statements/${getStatementIdUtil()}/revisions/${revisionId}/summary-flags`,
  );

export const getStatementSummaryRequest = ({ revisionId }) =>
  withDefaultContextAsSelectedProject().get(
    `/tieout/statements/${getStatementIdUtil()}/revisions/${revisionId}/summary`,
  );

export const getStatementSummaryDetailsRequest = ({ fileKey }) =>
  withDefaultContextAsSelectedProject().get(
    `/tieout/doc-chat/file-key/${fileKey}/process-type/${PROCESS_TYPES.SUMMARY_GENERATION}`,
  );

export const getStatementSummaryReprocessRequest = (reprocess) =>
  withDefaultContextAsSelectedProject().post(
    `/tieout/doc-chat/summary/re-process`,
    reprocess,
  );
